import classnames from 'classnames/bind';
import PropTypes from 'prop-types';

import styles from './WithTooltip.module.scss';

const cx = classnames.bind(styles);

const WithTooltip = ({className = '', children, tag = 'span', position = 'top', tooltip}) => {
  const Tag = tag;
  return tooltip ? (
    <Tag className={cx('root', className)}>
      <span className={cx('tooltip', `position-${position}`)}>{tooltip}</span>
      {children}
    </Tag>
  ) : null
}

WithTooltip.propTypes = {
  className: PropTypes.string,
  tag: PropTypes.string,
  tooltip: PropTypes.string.isRequired,
  position: PropTypes.oneOf(['top', 'bottom', 'left', 'right'])
}

export default WithTooltip;
